import React, { FC, useEffect, useState } from 'react';
import { Link } from '@mui/material';
import { AgentRequestResponse } from '../../structures/response/AgentRequestResponse';
import { getReportToSign } from '../../api/agent';
import { AgentReportResponse } from '../../structures/response/AgentReportResponse';
import ESignComponent from './ESignComponent';
import MfLinearSimpleProgress from '../UI/Progress/MfLinearSimpleProgress';
import commonQesESignHandler from './ESignHandlers/commonQesESignHandler';

interface Props {
  request: AgentRequestResponse | null;
}

const SignAgentReportComponent: FC<Props> = ({ request }) => {
  const [reportResponse, setReportResponse] =
    useState<AgentReportResponse | null>(null);

  const getData = async () => {
    try {
      if (request?.id) {
        const r = await getReportToSign(request.id);
        setReportResponse(r);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getData();
  }, [request?.id]);

  if (!reportResponse) {
    return <MfLinearSimpleProgress />;
  }

  return (
    <div>
      <Link target="_blank" href={reportResponse?.reportDocument?.viewUrl}>
        {reportResponse?.reportDocument?.name}
      </Link>
      <ESignComponent
        onSignCompleted={(v) => {
          commonQesESignHandler(v);
        }}
        documents={[reportResponse.reportDocument]}
      />
    </div>
  );
};

export default SignAgentReportComponent;
